import { useContext } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import HouseKioskShell from '../housekiosk/HouseKioskShell';
import { UserContext } from '../contexts/UserContext';
import { getHouseIdFromProfile } from '../housekiosk/utils';

export default function HouseKioskRoutes() {
  const { userProfile } = useContext(UserContext);
  const { houseId } = useParams<{ houseId?: string }>();

  type UserProfileLike = {
    mainRole?: string;
    role?: string;
    roles?: string[];
  };

  const profile = userProfile as unknown as UserProfileLike | null | undefined;

  const roleText = (
    `${profile?.mainRole ?? ''} ${profile?.role ?? ''} ` +
    `${Array.isArray(profile?.roles) ? profile!.roles.join(' ') : ''}`
  ).toUpperCase();

  const isTeacherLike = roleText.includes('TEACHER') || roleText.includes('ACORNLEAD');
  const isMascot = roleText.includes('MASCOT');
  const isKiosk = roleText.includes('KIOSK');
  const isStudent = roleText.includes('STUDENT');

  if (!isTeacherLike && !isMascot && !isKiosk && !isStudent) {
    return <Navigate to="/unauthorized" replace />;
  }

  const userType = isMascot ? 'mascot' : (isKiosk ? 'kiosk' : (isStudent ? 'student' : 'teacher'));
  const resolvedHouseId = isMascot ? (houseId ?? getHouseIdFromProfile(userProfile)) : undefined;

  return (
    <HouseKioskShell userType={userType} houseId={resolvedHouseId}>
      <Outlet />
    </HouseKioskShell>
  );
}
